/*eslint no-console:1 */
import axios from 'axios';
import AutocompleteBase from './AutocompleteBase';
// import {addListener} from '../lib/event';


export default class Autocomplete extends AutocompleteBase {

  constructor(el) {

    super(el);

    if (window.routes) {

      if (!this.isFilter) {
        this.url = window.routes['autocomplete'][0];
      } else {

        this.url = this.el.getAttribute('data-autocomplete-route');
      }
      this.axiosType = window.routes['autocomplete'][1];
    }
  }

  getResults(input) {

    if (window.routes) {
      return axios({
        method: this.axiosType,
        url: this.url,
        params: {
          q: input
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept-Language': document.documentElement.lang || 'en'
        }
      })
      .then(res => {

        return (res.data) ? Promise.resolve(res.data) : Promise.reject(new Error('no data received from server'));

      })
      .catch(error => {

       // console.log('[AUTOCOMPLETE] Error fetching results');

        this.suggestionList.style.display = 'none';
        this.suggestionList.innerHTML = '';

        return Promise.reject(error);
      });
    }

    throw new Error('[AUTOCOMPLETE] route is missing');
  }
};

